import React from 'react';

/**
 * Fängt einen Fehler beim Darstellen ab, damit die App nicht als leere Seite endet. Gezeigt wird ein deutscher Hinweis
 * mit „Neu laden“; das Protokoll nennt nur die Art des Fehlers, nie Inhalte.
 */
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: unknown): void {
    console.error('[ErrorBoundary] Darstellung fehlgeschlagen:', error instanceof Error ? error.name : typeof error);
  }

  render(): React.ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-xl p-8 text-center">
        <h1 className="font-serif text-2xl text-primary dark:text-white">Diese Ansicht konnte nicht geladen werden.</h1>
        <p className="mt-3 text-sm text-muted dark:text-gray-400">Bitte laden Sie die Seite neu. Bleibt der Fehler bestehen, wenden Sie sich an den Support.</p>
        <button type="button" className="btn-primary mt-6" onClick={() => window.location.reload()}>
          Neu laden
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
